
import { BaseService } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";
import { ISupportCategory } from "./SupportCategoryService";

export interface ISupportArticle {
    title: string;
    helpful: number;
    content: string;
    platform: string;
    created_at: string;
    not_helpful: number;
    external_id: string;
    category: ISupportCategory;
}

export class SupportArticleService extends BaseService {

    protected static instance: SupportArticleService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportArticleService.instance) SupportArticleService.instance = new SupportArticleService();
        return SupportArticleService.instance;
    }

    querySupportArticles(query: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/article", { query: this.normalizeParams(query) }));
    }

    getSingleSupportArticle(id: string): Promise<any> {
        return this.report(this.transport.get(`/hera/api/v1/support/article/${id}`));
    }

    markArticleHelpful(id: string, helpful: boolean): Promise<any> {
        return this.report(this.transport.patch(`/hera/api/v1/support/article/${id}/helpful`, { helpful }));
    }

}
